<div class="ag-cell-editor fx-layout-row fx-justify-space-between fx-align-center">
  <input #inputText (beforeinput)="validateKeypressEvent($event)" (paste)="validatePasteEvent($event)"
         [formControl]="control" matInput class="ag-input-field-input" type="text"/> @if (suffix) {
    <span
    >{{ suffix }}</span>
  }

  @if (control.invalid) {
    <div>
      <mat-icon fontSet="mdi" fontIcon="mdi-help-circle" class="tooltip-icon" [matTooltip]="errorTooltip"></mat-icon>
    </div>
  }
  <div>
    <mat-icon fontSet="mdi" fontIcon="mdi-check" (click)="stopEditing()"></mat-icon>
  </div>
</div>
